<template>
    <v-dialog v-model="dialog" max-width="1000px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            class="mx-2"
            v-bind="attrs"
            v-on="on"
            >เพิ่ม</v-btn>
        </template>

        <v-card outlined class="pa-3">
                <v-card-title ><strong>{{$t('ext_package_title')}}</strong></v-card-title>
                <v-divider class="ma-2"></v-divider>
                <div class="pl-5 pr-5">
                    <v-form ref="formData" lazy-validation>
                    <v-row>
                        <v-col>
                            <v-text-field outlined autofocus
                                :rules="[rules.required]"
                                :label="$t('ext_package_name_label')" 
                                v-model="editedItem.ext_package_name">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col>
                            <v-text-field outlined 
                                :label="$t('ext_package_unit_price_label')"
                                :rules="[rules.requiredNumber]"
                                v-model="editedItem.unit_price">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-select
                            :rules="[rules.required]"
                             v-model="editedItem.unit_code"
                             :items="unitItems"
                             item-text="unit_name"
                             item-value="unit_code"
                             :label="$t('ext_package_unit_code_label')"
                             >
                            </v-select>
                        </v-col>
                        <v-col>
                            <v-select
                            :rules="[rules.required]"
                             v-model="editedItem.package_type"
                             :items="packageTypeItems"
                             item-text="text"
                             item-value="value"
                             label="ประเภทของบริการเสริม"
                             >
                            </v-select>
                        </v-col>
                        <v-col>
                            <v-checkbox v-model="editedItem.user_can_select" label="สำหรับลูกค้าเลือกซื้อได้"></v-checkbox>
                        </v-col>
                    </v-row>
                   
                    </v-form> 
                </div>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveDialog">บันทึก</v-btn>
                    <v-btn color="primary" @click="closeDialog"> ยกเลิก</v-btn>
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

export default {
    name: 'DlgExtPackage',
    data: () => ({
        rules: {
            required: value => !!value || 'กรุณากรอกข้อมูล.',
            requiredNumber: value => !!value || 'กรุณากรอกข้อมูลที่เป็นตัวเลข',
        },
        dialog: false,
        editedItem: {},
        isEdit: false,
        unitItems: [],
        packageTypeItems: [
            {value: '1', text: 'ช่วงระยะเวลา'},
            {value: '2', text: 'รายครั้ง'}
        ]
    }),
    methods: {
        loadDropdownUnit() {
            if (this.unitItems && this.unitItems.length > 0) return;
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.dropdown.unit,
                { headers: Staff.getTokenHeader()}
            ).then((rs) => {
                this.$store.commit('finishLoading',que)
                this.unitItems = rs.data
            })
        },
        saveDialog() {
            if (!this.$refs.formData.validate()) {
                return;
            }
            let url = this.isEdit ? config.api.url.manage.ext_package.update_ext_package + this.editedItem.ext_package_id : config.api.url.manage.ext_package.insert_ext_package;
            var que = this.$store.commit('addLoading')
            axios.post(url, this.editedItem, { headers: Staff.getTokenHeader()}).then(() => {
                this.$store.commit('finishLoading',que)
                 this.closeDialog(true);
            })
            .catch(error => {
                this.$store.commit('finishLoading',que)
                this.$router.push({name:'Error',params:error});
            });
           
        },
        closeDialog(ret) {
            this.editedItem = {};
            this.dialog = false;
            this.isEdit = false;
            this.$emit("onCloseDialog", ret);
        },
        show(item) {
            this.dialog = true;
            this.editedItem = item;
            this.isEdit = true;
        }
    },
    mounted() {
        this.loadDropdownUnit();
    }
}
</script>